/**
 * 系统管理后台路由模块
 * 仅超级管理员可访问，使用独立 Layout
 */
export default [
  {
    path: 'platform',
    name: 'admin_platform',
    meta: {
      title: '平台总览',
      breadcrumb: ['系统管理', '平台总览'],
    },
    component: () => import('@/views/admin/PlatformOverview.vue'),
  },
  {
    path: 'runtime-health',
    name: 'admin_runtime_health',
    meta: {
      title: '运行时健康',
      breadcrumb: ['系统管理', '运行时健康'],
    },
    component: () => import('@/views/admin/RuntimeHealth.vue'),
  },
  {
    path: 'user',
    name: 'admin_user',
    meta: {
      title: '用户管理',
      breadcrumb: ['系统管理', '用户管理'],
    },
    component: () => import('@/views/system/UserManage.vue'),
  },
  {
    path: 'role',
    name: 'admin_role',
    meta: {
      title: '角色管理',
      breadcrumb: ['系统管理', '角色管理'],
    },
    component: () => import('@/views/system/RoleManage.vue'),
  },
  {
    path: 'menu',
    name: 'admin_menu',
    meta: {
      title: '菜单管理',
      breadcrumb: ['系统管理', '菜单管理'],
    },
    component: () => import('@/views/system/MenuManage.vue'),
  },
  {
    path: 'broadcast',
    name: 'admin_broadcast',
    meta: {
      title: '系统广播',
      breadcrumb: ['系统管理', '系统广播'],
    },
    component: () => import('@/views/admin/BroadcastManage.vue'),
  },
  {
    path: 'security',
    name: 'admin_security',
    meta: {
      title: '安全设置',
      breadcrumb: ['系统管理', '安全设置'],
    },
    component: () => import('@/views/admin/SecurityManage.vue'),
  },
  {
    path: 'login-log',
    name: 'admin_login_log',
    meta: {
      title: '登录日志',
      breadcrumb: ['系统管理', '登录日志'],
    },
    component: () => import('@/views/admin/LoginLogManage.vue'),
  },
  {
    path: 'config',
    name: 'admin_config',
    meta: {
      title: '系统参数',
      breadcrumb: ['系统管理', '系统参数'],
    },
    component: () => import('@/views/admin/SystemConfig.vue'),
  },
  {
    path: 'logo',
    name: 'admin_logo',
    meta: {
      title: 'Logo 设置',
      breadcrumb: ['系统管理', 'Logo 设置'],
    },
    component: () => import('@/views/system/LogoConfig.vue'),
  },
  {
    path: 'log',
    name: 'admin_log',
    meta: {
      title: '操作日志',
      breadcrumb: ['系统管理', '操作日志'],
    },
    component: () => import('@/views/mw_views/project/log.vue'),
  },
];
